<template>
  <div>
    <div>
      <label
        class="block aisea-text-14-600-black text-sm text-left font-bold mb-2"
        >{{ label }} <span v-if="required" style="color: red;">*</span></label
      >
      <div>
        <!-- readonlyモードではテキスト表示 -->
        <template v-if="mode === 'readonly'">
          <div class="readonly-text aisea-text-16-400-black">
            {{ localValue }}
          </div>
        </template>
        <!-- input/disabledモードでは入力フォーム -->
        <template v-else>
          <input
            :type="type"
            :value="localValue"
            :placeholder="placeholder"
            :disabled="mode === 'disabled'"
            class="input-box"
            @input="onInputChange"
          />
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import { createNamespacedHelpers } from "vuex";

// Store
const { mapGetters: mapGettersOfCrewDataManagement } = createNamespacedHelpers(
  "crewDataManagement"
);

export default {
  props: {
    id: { type: String, required: true },
    label: { type: String, default: "" },
    required: { type: Boolean, default: false },
    placeholder: { type: String, default: "入力してください..." },
    mode: {
      type: String,
      default: "input",
      validator: value => ["input", "disabled", "readonly"].includes(value),
    },
    value: { type: [String, Number], default: "" },
    type: { type: String, default: "text" },
    displayData: { type: String, default: "" },
  },
  data() {
    return {
      localValue: this.value,
    };
  },
  watch: {
    value(newValue) {
      this.localValue = newValue;
    },
  },
  created() {
    this.initializeOptions();
  },
  methods: {
    ...mapGettersOfCrewDataManagement(["getLatestCutoffDate"]),

    async initializeOptions() {
      // 締め日機能の場合、直近の締め日を表示
      if (this.mode === "readonly" && this.displayData === "vesselCutoff") {
        this.localValue = this.getLatestCutoffDate();
      }
    },

    onInputChange(event) {
      const value = event.target.value;
      this.localValue = value;
      this.$emit("input", { id: this.id, value });
    },
  },
};
</script>

<style lang="scss" scoped>
.input-box {
  width: 100%;
  padding: 0.5rem;
  font-size: 1rem;
  border: 1px solid #ccc;
  border-radius: 4px;
  transition: border-color 0.3s ease;

  &[disabled] {
    background-color: #eceaea;
    color: #6b6d6e;
    cursor: not-allowed;
  }
}

.readonly-text {
  padding: 0.5rem;
}
</style>
